export default "__VITE_ASSET__Cg15xNhM__"